import React from 'react';
import { useSelector } from 'react-redux';

import MediaGrid from 'dpl/components/MediaGrid';
import { BREED_ID } from 'dpl/constants/query_params';
import useResourceQuery from 'dpl/shared/fetching/hooks/useResourceQuery';
import { photographsResourceDefinition } from 'dpl/shared/utils/tptConnectResourceDefinitions';

import BreederProfileDetailsCardContainer from '../BreederProfileDetailsCardContainer';

export default function BreederProfileMainContainer() {
  const { breederProfileId } = useSelector(({ server }) => ({
    breederProfileId: server.breederProfileId
  }));

  const breedId = useSelector(({ queryParams }) => queryParams[BREED_ID]);

  const {
    value: { data: gallery },
    isFetching: isFetchingGallery
  } = useResourceQuery(
    photographsResourceDefinition(breederProfileId, {
      [BREED_ID]: breedId
    })
  );

  return (
    <div className="BreederProfileMainContainer container-xxl">
      <div className="row slim-gutters gap-y-20">
        <div className="col-12 col-lg-8">
          <MediaGrid
            isLoading={isFetchingGallery}
            gallery={gallery}
            carouselType="program"
          />
        </div>
        <div className="col-12 col-lg-4">
          <BreederProfileDetailsCardContainer />
        </div>
      </div>
    </div>
  );
}
